import axios from 'axios';
import swal from 'sweetalert2';

import CmsCache from './cmsCache';

axios.defaults.withCredentials = true;

const loadingOpts = {
  color: '#009ae3',
  backgroundColor: '#000000',
  opacity: 0.8,
};

function handleCmsError(error) {
  console.error(error);
  const data = error.response.data || 'An error occured...';
  if (typeof data === 'string') {
    swal.fire('Uh-Oh!', data, 'error');
  } else {
    let message = [];
    if (data.message) {
      message.push(data.message);
    }
    if (data.errors) {
      Object.keys(data.errors).forEach(key => {
        message.push(`${key}: ${data.errors[key].join('. ')}`);
      });
    }
    swal.fire('Uh-Oh!', message.join('<br>'), 'error');
  }
}


const $CMS_CACHE = new CmsCache;
window.$CMS_CACHE = $CMS_CACHE;

export default {
  install: (app, options) => {
    app.prototype.$CMS_CLONE = async (subject, routeParams) => {
      return await axios({
        url: route(`cms.${subject}.clone`, routeParams),
        method: "GET"
      }).then(async (resp) => {
        return resp.data;
      }).catch(error => {
        switch (error.response.status) {
          case 401:

            break;
          case 500:
            handleCmsError(error)
            break;
          default:
            handleCmsError(error)
        }
      });
    };

    app.prototype.$CMS_RESTORE = async (subject, routeParams) => {
      return await axios({
        url: route(`cms.${subject}.restore`, routeParams),
        method: "GET"
      }).then(async (resp) => {
        return resp.data;
      }).catch(error => {
        switch (error.response.status) {
          case 401:
            router.push('/unauthorized');
            break;
          case 500:
            handleCmsError(error)
            break;
          default:
            handleCmsError(error)
        }
      });
    };

    app.prototype.$CMS_GET = async (subject, routeParams, silent) => {

      // const cacheKey = btoa(JSON.stringify({ subject, routeParams }));
      // const cached = $CMS_CACHE.get(cacheKey);

      // if (cached) {
      //   return new Promise((resolve, reject) => {
      //     console.log('cached');
      //     resolve(cached);
      //   });
      // }

      return await axios({
        url: route(`cms.${subject}`, routeParams),
        method: "GET"
      }).then(async (resp) => {
        // $CMS_CACHE.set(cacheKey, resp.data, 10000);
        return resp.data;
      }).catch(error => {
        if (silent) {
          return error;
        } else {
          switch (error.response.status) {
            case 401:
              router.push('/unauthorized');
              break;
            case 500:
              handleCmsError(error)
              break;
            default:
              handleCmsError(error)
          }
        }
      });
    };

    app.prototype.$CMS_POST = async (subject, routeParams, data, options) => {
      if (!options) {
        options = {}
      }
      return await axios({
        url: route(`cms.${subject}`, routeParams),
        method: "POST",
        data,
        options
      }).then(async (resp) => {
        return resp.data;
      }).catch(error => {
        switch (error.response.status) {
          case 401:
            router.push('/unauthorized');
            break;
          case 500:
            handleCmsError(error)
            break;
          default:
            handleCmsError(error)
        }
      });
    };

    app.prototype.$CMS_PUT = async (subject, routeParams, data, options) => {
      if (!options) {
        options = {}
      }
      return await axios({
        url: route(`cms.${subject}`, routeParams),
        method: "PUT",
        data,
        options
      }).then(async (resp) => {
        return resp.data;
      }).catch(error => {
        switch (error.response.status) {
          case 401:
            router.push('/unauthorized');
            break;
          case 500:
            handleCmsError(error)
            break;
          default:
            handleCmsError(error)
        }
      });
    };

    app.prototype.$CMS_UPDATE = async (subject, routeParams, data, silent) => {
      let loader = null;
      let minTime = 0;
      if (!silent) {
        minTime = 3000;
        loader = app.prototype.$loading.show(loadingOpts);
      }
      const startTime = Date.now();
      const expectedTime = startTime + minTime;
      return await axios({
        url: route(`cms.${subject}.update`, routeParams),
        method: "PUT",
        data
      }).then(async (resp) => {
        const endTime = Date.now();
        const diffTime = endTime - expectedTime;
        const timeout = diffTime > 100 ? diffTime : 100;
        setTimeout(() => {
          if (loader) {
            loader.hide();
          }
          if (resp.data.status === 'error') {
            swal.fire('Uh-Oh!', resp.data.message || 'An error occured...', 'error');
          } else {
            if (!silent) {
              app.prototype.$noty.success(resp.data.message || 'Updated!');
            }
          }
        }, timeout);
        if (resp.data.status === 'error') {
          return false;
        } else {
          return resp.data;
        }
      }).catch(error => {
        if (loader) {
          loader.hide();
        }
        if (error.response) {
          switch (error.response?.status) {
            case 401:

              break;
            case 500:
              handleCmsError(error)
              break;
            default:
              handleCmsError(error)
          }
        } else {
          handleCmsError(error)
        }
      });
    };

    app.prototype.$CMS_CREATE = async (subject, routeParams, data, silent) => {
      return await axios({
        url: route(`cms.${subject}.store`, routeParams),
        method: "POST",
        data
      }).then(async (resp) => {
        if (resp.data.status === 'error') {
          swal.fire('Uh-Oh!', resp.data.message || 'An error occured...', 'error');
        } else {
          if (!silent) {
            app.prototype.$noty.success('Created!');
          }
          return resp.data;
        }
      }).catch(error => {
        if (error.response) {
          switch (error.response.status) {
            case 401:

              break;
            case 500:
              handleCmsError(error)
              break;
            default:
              handleCmsError(error)
          }
        } else {
          handleCmsError(error)
        }
      });
    };

    app.prototype.$CMS_DELETE = async (subject, routeParams) => {
      return await axios({
        url: route(`cms.${subject}.destroy`, routeParams),
        method: "DELETE"
      }).then(async (resp) => {
        if (resp.data.status === 'error') {
          swal.fire('Uh-Oh!', resp.data.message || 'An error occured...', 'error');
        } else {
          return resp.data;
        }
      }).catch(error => {
        if (error.response) {
          switch (error.response.status) {
            case 401:

              break;
            case 500:

              handleCmsError(error)
              break;
            default:
              handleCmsError(error)
          }
        } else {
          handleCmsError(error)
        }
      });
    };

    app.prototype.$CMS_FORCEDELETE = async (subject, routeParams) => {
      return await axios({
        url: route(`cms.${subject}.forcedelete`, routeParams),
        method: "GET"
      }).then(async (resp) => {
        if (resp.data.status === 'error') {
          swal.fire('Uh-Oh!', resp.data.message || 'An error occured...', 'error');
        } else {
          return resp.data;
        }
      }).catch(error => {
        if (error.response) {
          switch (error.response.status) {
            case 401:

              break;
            case 500:

              handleCmsError(error)
              break;
            default:
              handleCmsError(error)
          }
        } else {
          handleCmsError(error)
        }
      });
    };

    app.prototype.$CMS_FILE_UPLOAD = async (data) => {
      let loader = app.prototype.$loading.show(loadingOpts);
      return await axios({
        url: route('cms.storage.store'),
        method: "POST",
        data
      }).then(async (resp) => {
        loader.hide();
        if (resp.data.status === 'error') {
          swal.fire('Uh-Oh!', resp.data.message || 'An error occured...', 'error');
        } else {
          app.prototype.$noty.success('File uploaded!');
          return resp.data;
        }
      }).catch(error => {
        loader.hide();
        switch (error.response?.status) {
          case 401:
            router.push('/unauthorized');
            break;
          case 500:
            // router.push('/error');
            handleCmsError(error)
            break;
          default:
            handleCmsError(error)
        }
      });
    };

    app.prototype.$CMS_FILE_DELETE = async (data) => {
      return await axios({
        url: route('cms.storage.delete'),
        method: "DELETE",
        data
      }).then(async (resp) => {
        if (resp.data.status === 'error') {
          swal.fire('Uh-Oh!', resp.data.message || 'An error occured...', 'error');
        } else {
          return resp.data;
        }
      }).catch(error => {
        switch (error.response.status) {
          case 401:
            router.push('/unauthorized');
            break;
          case 500:
            // router.push('/error');
            handleCmsError(error)
            break;
          default:
            handleCmsError(error)
        }
      });
    };

    app.prototype.$CMS_ALERT = (opts) => {
      return swal.fire(opts)
    };

    app.prototype.$CMS_ERROR = (error) => {
      handleCmsError(error);
    };
  }
}
